<div class="ViewButton">
    <mat-icon class="example-icon text-blue-500 cursor-pointer" aria-hidden="false" matTooltip="View" i18n-tooltip="View" svgIcon="mat_solid:remove_red_eye" 
    (click)="onClick($event)"></mat-icon>
</div>